/* eslint-disable jsx-a11y/anchor-is-valid */
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { InternalLabelData } from "../../../models/InternalLabelData";
import { LocationData } from "../../../models/LocationData";
import DataSvc from "../../../services/dataSvc";
import { Checkbox } from "../../FormElement/Checkbox";
import "./styles.scss";

export interface IModalAssignInternalLabelsProps {
  locationData: LocationData;
  onClose: () => void;
  onUpdateAssignLabels: (addIds: string[], deleteIds: string[]) => void;
}

export const ModalAssignInternalLabels: React.FunctionComponent<
  IModalAssignInternalLabelsProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityManagementPage.modalAssignInternalLabels.${key}`);
  const { locationData, onClose, onUpdateAssignLabels } = props;

  const { data: internalLabels } = useQuery(["internalLabels"], () =>
    DataSvc.getInternalLabels({})
  );

  const [selected, setSelected] = useState<string[]>(
    locationData.internal_labels?.map((l) => l.id) || []
  );

  const handleCheck = (id: string, checked: boolean) => {
    setSelected((prev) =>
      checked ? [...prev, id] : prev.filter((v) => v !== id)
    );
  };

  const handleSubmit = () => {
    if (!internalLabels) return;
    const originalIds = locationData.internal_labels?.map((l) => l.id) || [];
    const addIds = selected.filter((id) => !originalIds.includes(id));
    const deleteIds = originalIds.filter((id) => !selected.includes(id));
    onUpdateAssignLabels(addIds, deleteIds);
  };

  return (
    <div className="modal modal-default modal-assign-internal-labels">
      <div className="modal-mains">
        <a aria-label="Close" className="btn-close" onClick={onClose}></a>
        <div className="top-title">{locationData.name}</div>
        <div className="filter-bar flex-grid">
          <div className="lefts">
            <div className="title">{t("select_internal_labels")}</div>
          </div>
        </div>
        <div className="overlay">
          <div className="content-selection-wrap">
            <div className="selection-wrap">
              {internalLabels &&
                internalLabels.data.length > 0 &&
                internalLabels.data.map((label: InternalLabelData) => (
                  <div className="items" key={label.id}>
                    <div className="checkbox-wrap have-txt">
                      <Checkbox
                        checked={selected.includes(label.id)}
                        label={label.name}
                        subLabel={label.description || ""}
                        id={`checkbox-internal-label-${label.id}`}
                        onChange={(checked: boolean) =>
                          handleCheck(label.id, checked)
                        }
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="bottom-btns">
          <a className="btn btn-border" onClick={onClose}>
            {t("cancel")}
          </a>
          <a className="btn btn-blue" onClick={handleSubmit}>
            {t("submit")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalAssignInternalLabels;
